import React from 'react';
import backgroundImage from './background.jpg';
import Profile from './components/Profile';
import LinksContainer from './components/LinksContainer';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="App" style={{ '--bg-image': `url(${backgroundImage})` }}>
      <div className="container">
        <Profile />
        <LinksContainer />
        <Footer />
      </div>
    </div>
  );
}

export default App;
